// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3qkHs","title":"InfoRow_title__1dy0N"};